import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BookOpen, ArrowUpRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * RelatedPostsInline — compact horizontal list of related blog posts.
 * Used inside region cards on the Regions page.
 */
const RelatedPostsInline = ({ regionSlug, limit = 3 }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { localizedPath } = useLanguage();

  useEffect(() => {
    if (!regionSlug) return;
    let cancelled = false;
    setLoading(true);
    axios
      .get(`${API}/related/regiao/${regionSlug}?limit=${limit}`)
      .then((res) => {
        if (!cancelled) setPosts(res.data?.posts || []);
      })
      .catch(() => {
        if (!cancelled) setPosts([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [regionSlug, limit]);

  if (loading || posts.length === 0) return null;

  return (
    <div
      data-testid={`related-posts-${regionSlug}`}
      className="mt-6 pt-5 border-t border-brand-accent/30"
    >
      <p className="text-[10px] uppercase tracking-[0.2em] text-brand-text-secondary font-semibold mb-3 flex items-center gap-1.5">
        <BookOpen className="w-3 h-3" />
        Leia também
      </p>
      <ul className="space-y-2">
        {posts.map((p) => (
          <li key={p.slug}>
            <Link
              to={localizedPath(`/journal/${p.slug}`)}
              className="group flex items-center gap-2 text-sm text-brand-text hover:text-brand-primary transition-colors"
              data-testid={`inline-post-${p.slug}`}
            >
              <ArrowUpRight className="w-3.5 h-3.5 text-brand-primary opacity-60 group-hover:opacity-100 transition-opacity shrink-0" />
              <span className="line-clamp-1">{p.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RelatedPostsInline;
